import {
  DEFAULT_ORDER,
  UPDATE_RESULTS_ORDER,
  TOGGLE_HIDDEN_OPTIONS,
  TOGGLE_LIMIT_TO_TAGS,
  UPDATE_LIMITED_TAGS,
  TOGGLE_HIDE_TAGS,
  UPDATE_HIDDEN_TAGS,
  UPDATE_CATEGORY_PROP,
  TOGGLE_SHORT_LIST,
  UPDATE_FILTER_OPTIONS,
  CUSTOMIZED_ORDER
} from "../actions/filterOptions";

const defaultSectionState = {
  order: DEFAULT_ORDER,
  displayHiddenOptions: true,
  limitToTags: false,
  limitedTags: [],
  hideTags: false,
  hiddenTags: [],
  categoryProp: "Input-Based Category",
  shortList: false
};

const defaultState = {
  monitoring: {
    ...defaultSectionState
  },
  assessment: {
    ...defaultSectionState
  },
  controlRules: {
    ...defaultSectionState
  },
  enforcement: {
    ...defaultSectionState
  }
};

const updateSection = (state, section, update) => ({
  ...state,
  [section]: {
    ...state[section],
    ...update
  }
});

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_CATEGORY_PROP:
      return updateSection(state, action.section, {
        categoryProp: action.value
      });
    case UPDATE_RESULTS_ORDER:
      return updateSection(state, action.section, {
        order: action.order
      });
    case TOGGLE_HIDDEN_OPTIONS:
      return updateSection(state, action.section, {
        displayHiddenOptions: !state[action.section].displayHiddenOptions
      });
    case TOGGLE_LIMIT_TO_TAGS:
      return updateSection(state, action.section, {
        limitToTags: !state[action.section].limitToTags,
        hideTags: false
      });
    case TOGGLE_HIDE_TAGS:
      const hide = !state[action.section].hideTags;
      return updateSection(state, action.section, {
        hideTags: hide,
        limitToTags: false
      });
    case UPDATE_LIMITED_TAGS:
      return updateSection(state, action.section, {
        limitedTags: action.tags
      });
    case UPDATE_HIDDEN_TAGS:
      return updateSection(state, action.section, {
        hiddenTags: action.tags
      });
    case TOGGLE_SHORT_LIST:
      var order = !state[action.section].shortList ? CUSTOMIZED_ORDER : state[action.section].order; //if turning shortList on then use custom sort, if turning off, leave as is
      return updateSection(state, action.section, {
        shortList: !state[action.section].shortList,
        displayHiddenOptions: false,
        order: order
      });
    case UPDATE_FILTER_OPTIONS:
      return updateSection(state, action.section, action.options);
    default:
      return state;
  }
};
